import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import NotificationList from "./notificationList";

const Notification = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="Notification" />

      <div className="container ">
        <section className="">
          <NotificationList titleText={"Notification"} />
        </section>
        <section className="top-space "></section>
      </div>
    </>
  );
};
export default Notification;
